
<div class="dialog add-multiple-securities-dialog">
  <div mat-dialog-title>{{ dialogTitle }}</div>
  <mat-dialog-content>
    @if (!isUiTest) {
      <irb-inventory-grid id="add-multiple-securities-dialog-grid"
        style ="height: 450px"
        [showSideBar] ='true'
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        [style.minHeight]="'450px'"
        [componentName] = "componentName"
        [footerContent] = "footerContent"
        [frameworkComponents]="frameworkComponents"
      ></irb-inventory-grid>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="closeDialog()" class="btn-medium-secondary">Cancel</button>
    <button id="addSelectedSecButton" (click)="addSecurities()"
      [disabled]="disableAddBtn"
    class="btn-medium-primary">Add selected securities</button>
  </mat-dialog-actions>
</div>
